"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.mergeRefs = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var mergeRefs = function mergeRefs(forwardedRef) {
  var ref, setRef; // Check the shape of forwardedRef prop so we can properly pass it
  // through as expected while also making use of the ref ourselves
  // (i.e. support React.createRef() as well as functional refs)

  if (forwardedRef && (0, _typeof2["default"])(forwardedRef) === 'object' && 'current' in forwardedRef) {
    // if given a compatible forwardedRef, just use it
    setRef = ref = forwardedRef;
  } else {
    // otherwise create our own
    ref = /*#__PURE__*/_react["default"].createRef();

    if (typeof forwardedRef === 'function') {
      // if given a functional forwardedRef, combine it with ours
      setRef = function setRef(el) {
        forwardedRef(el);
        ref.current = el;
      };
    } else {
      // otherwise just set ours directly
      setRef = ref;
    }
  }

  return {
    ref: ref,
    setRef: setRef
  };
};

exports.mergeRefs = mergeRefs;
var _default = mergeRefs;
exports["default"] = _default;